import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import useAuthentication from "../../hooks/useAuthentication";
import { frontendRoutes } from "../../utility/frontendRoutes";
import AppFooter from "../../common-components/AppFooter";
import ProductsFeed from "./ProductsFeed";

const HomePage = () => {
  const { currentUser, isLoggedIn } = useAuthentication();
  const navigate = useNavigate();

  const greeting =
    isLoggedIn && currentUser?.firstName
      ? `Hello, ${currentUser.firstName} 👋`
      : "Welcome to Ngwaahia!";

  return (
    <>
      {/* pb clears AppFooter, which is position:fixed to the viewport bottom
          — without it the last feed row would sit underneath the footer. */}
      <Box
        sx={{
          maxWidth: 1100,
          mx: "auto",
          px: { xs: 2, md: 4 },
          pt: 3,
          pb: "76px",
        }}
      >
        {/* Greeting */}
        <Typography
          variant="h6"
          fontWeight={700}
          color="#046287"
          sx={{ mb: 2, textAlign: { xs: "center", md: "left" } }}
        >
          {greeting}
        </Typography>

        {/* Search bar — a launcher for the full SearchPage (products, shops
            and people, with filters and sorting). Focusing it, or typing into
            it, hands off straight away; SearchPage autofocuses its own input. */}
        <TextField
          fullWidth
          placeholder="What are you looking for?"
          value=""
          onFocus={() => navigate(frontendRoutes.SEARCH)}
          onChange={(e) => {
            const q = e.target.value.trim();
            navigate(
              q
                ? `${frontendRoutes.SEARCH}?q=${encodeURIComponent(q)}`
                : frontendRoutes.SEARCH,
            );
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "#046287" }} />
              </InputAdornment>
            ),
          }}
          sx={{
            mb: 4,
            "& .MuiOutlinedInput-root": {
              borderRadius: 3,
              bgcolor: "white",
            },
          }}
        />

        {/* Products feed. Recurring shop/people recommendation rows are
            interleaved inside it (see ProductsFeed.jsx). */}
        <ProductsFeed />
      </Box>
      <AppFooter />
    </>
  );
};

export default HomePage;
